const zhTw = {
    hello: "hello tw"
}
export default zhTw